import { createAction } from '@reduxjs/toolkit';
export const SUBMIT_FEEDBACK = 'SUBMIT_FEEDBACK';
export const submitFeedbackAction = createAction(SUBMIT_FEEDBACK);